import React, { Dispatch, SetStateAction } from 'react'
import { styled } from '@mui/system'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Modal, Typography } from '@mui/material'
import { generateUtilityClasses } from '@mui/material'
import DropdownFieldSearch from '../../../../../ui/DropdownFieldSearch'
import { DateField, DropdownCheckboxes } from '../../../../../ui'
import { selectDropdownByName, selectDropdownByNameActiveOnly } from '../../../../../services'
import { useSelector } from 'react-redux'

const classes = generateUtilityClasses('form', ['root', 'row', 'btnWrap'])

const StyledBox = styled('form')(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.background.main,
    padding: theme.spacing(3),
    minWidth: '350px',
    maxWidth: '350px',
  },
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  [`& .${classes.btnWrap}`]: {
    marginTop: '20px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-end',
  },
}))

interface Props {
  open: boolean
  handleClose: Dispatch<SetStateAction<boolean>>
  formValues: any
}

const FilteringModal = ({ open, handleClose, formValues }: Props) => {
  const branch = useSelector((state) => selectDropdownByNameActiveOnly(state, 'Branch'))
  const cashier = useSelector((state) => selectDropdownByNameActiveOnly(state, 'UserAll'))
  const paymentForm = useSelector((state) => selectDropdownByName(state, 'PaymentForm'))
  const paymentMethod = useSelector((state) => selectDropdownByName(state, 'PaymentMethod'))

  return (
    <Dialog open={open} onClose={handleClose}>
      <form>
        <DialogTitle>Payments</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} py={1}>
            <Grid item xs={12}>
              <DateField name='StartDate' label='Start Date' fullWidth defaultValue={formValues?.StartDate} />
            </Grid>
            <Grid item xs={12}>
              <DateField name='EndDate' label='End Date' fullWidth defaultValue={formValues?.EndDate} />
            </Grid>

            <Grid item xs={12}>
              <DropdownFieldSearch
                name='FilterByCashier'
                label='Filter By Cashier Branch?'
                options={[
                  { key: true, value: 'Yes' },
                  { key: false, value: 'No' },
                ]}
                optionKey={'key'}
                optionValue={'value'}
                fullWidth
                defaultValue={formValues?.FilterByCashier}
              />
            </Grid>

            {cashier && (
              <Grid item xs={12}>
                <DropdownCheckboxes
                  name='Cashier'
                  label='Cashier'
                  options={cashier}
                  optionKey='UserID'
                  optionValue='UserCode'
                  fullWidth
                  defaultValue={formValues?.Cashier}
                />
              </Grid>
            )}

            {branch && (
              <Grid item xs={12}>
                <DropdownCheckboxes
                  name='Branch'
                  label='Branch'
                  options={branch}
                  optionKey={'BranchID'}
                  optionValue={'Branch'}
                  fullWidth
                  defaultValue={formValues?.Branch}
                />
              </Grid>
            )}

            {paymentForm && (
              <Grid item xs={12}>
                <DropdownCheckboxes
                  name='PaymentForm'
                  label='Payment Form'
                  options={paymentForm?.ReturnData}
                  optionKey={'ID'}
                  optionValue={'PaymentForm'}
                  fullWidth
                  defaultValue={formValues?.PaymentForm}
                />
              </Grid>
            )}

            {paymentMethod && (
              <Grid item xs={12}>
                <DropdownCheckboxes
                  name='PaymentMethod'
                  label='Payment Method'
                  options={paymentMethod?.ReturnData}
                  optionKey={'ID'}
                  optionValue={'PaymentMethod'}
                  fullWidth
                  defaultValue={formValues?.PaymentMethod}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='primary' type='submit'>
            Run
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default FilteringModal
